import ResizeBar from "./ResizeBar";
import { useState, useEffect, useRef } from 'react';
import DownIcon from '@material-ui/icons/ArrowDropDown';
import UpIcon from '@material-ui/icons/ArrowDropUp';



export default function FilesystemColumnHeader({
  perscribedWidth,
  sortBy,
  setSortBy,
  onColumnSizeChange,
  iiCol,
  col,
}){

  const renderedWidthRef = useRef();

  let { property, display } = col;

  


  return (
    <div 
      filesystemHeader={display}
      style={{
      position:'relative',
      width:perscribedWidth,
      paddingLeft:5,
      textOverflow:'ellipsis',
      overflow:'hidden',

    }}
      ref={el => {
        if( el ){
          //console.log("RESIZING " + JSON.stringify(col));
          //console.log({perscribedWidth:, actualWidth:el.getBoundingClientRect().width})
          let renderedWidth = el.getBoundingClientRect().width;
          renderedWidthRef.current = renderedWidth;
        }
      }}

      onClick={() => {

        if( sortBy && sortBy.sortBy === property ){
          setSortBy({
            sortBy:property,
            descending:!sortBy.descending
          })
        }else{
          setSortBy({
            sortBy:property,
            descending:true
          })
        }


      }}

    >
      <div style={{
        width:'100%',
        alignItems:'center',
      }} class="sg-row">
        <div> {display} </div>
        <div class="flex-expand"/>
        {sortBy && sortBy.sortBy === property && (
          sortBy.descending ? <DownIcon style={{fontSize:18,paddingRight:5}}/> : <UpIcon style={{fontSize:18,paddingRight:5}}/>
        )}
      </div>

      <ResizeBar {...{
        col,
        columnIndex:iiCol,
        width:perscribedWidth,
        onColumnSizeChange,
        renderedWidthRef,
        minWidth:80
      }}
      />


      {false && <div style={{color:'red'}} class="abs-right">
        {iiCol+"; "+perscribedWidth}
      </div>}


    </div>
  )

}
